<template>
    <div class="border-y border-gray-200 bg-white py-8 dark:border-default dark:bg-surface-card">
        <div class="container">
            <h2
                class="mb-8 text-center font-heading text-2xl font-bold text-gray-900 sm:text-3xl dark:text-txt-headings"
            >
                Dôverujú nám
            </h2>

            <div>
                <div class="grid grid-cols-2 items-center gap-4 sm:grid-cols-4 lg:grid-cols-8">
                    <div
                        v-for="partner in partners"
                        :key="partner.name"
                        class="flex h-20 min-w-0 items-center justify-center rounded-xl px-4 py-3 dark:bg-white"
                    >
                        <img
                            v-if="partner.logo"
                            :src="partner.logo"
                            :alt="partner.name"
                            class="max-h-full max-w-full object-contain grayscale transition-[filter] duration-200 hover:grayscale-0"
                        />
                        <div v-else class="text-center text-sm font-medium text-gray-400">
                            {{ partner.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Partner {
    name: string
    logo: string
}

const fallbackPartners: Partner[] = [
    { name: 'Tatra banka', logo: '/images/coop/tatra-banka.png' },
    { name: 'MIRRI', logo: '/images/coop/miiri.png' },
    { name: 'Nexteria', logo: '/images/coop/nexteria.png' },
    { name: 'IBM', logo: '/images/coop/ibm.png' },
    { name: 'MHSR', logo: '/images/coop/mhsr.png' },
    { name: 'Bloomreach', logo: '/images/coop/bloomreach.png' },
    { name: 'NSP', logo: '/images/coop/nsp.png' },
    { name: 'TIS', logo: '/images/coop/tis.png' }
]

const { data: partnerData } = await useAsyncData<Partner[]>(
    'homepage-partners',
    () => $fetch('/api/homepage/partners'),
    {
        server: true,
        default: () => fallbackPartners
    }
)

const partners = computed(() => {
    if (!Array.isArray(partnerData.value) || partnerData.value.length === 0) {
        return fallbackPartners
    }

    const validPartners = partnerData.value.filter((partner) => Boolean(partner?.name && partner?.logo))
    return validPartners.length > 0 ? validPartners : fallbackPartners
})
</script>
